/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_LANDING = "ON_LANDING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_PASO_2 = "ON_PASO_2";

export const ON_PASO_2_SUCCESS = "ON_PASO_2_SUCCESS";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_CONFIRMACION = "ON_CONFIRMACION";

export const ON_MOCK = "ON_MOCK";

export const ON_DATOS_PERSONALES = "ON_DATOS_PERSONALES";
export const ON_DATOS_SUCURSAL = "ON_DATOS_SUCURSAL";
export const ON_TIPOS_TRAMITE = "ON_TIPOS_TRAMITE";
export const ON_FECHA_TURNO = "ON_FECHA_TURNO";
export const ON_HORA_TURNO = "ON_HORA_TURNO";
export const ON_FECHA_TURNO_HORADEFAULT = "ON_FECHA_TURNO_HORADEFAULT";
export const ON_TURNO_AGENDADO = "ON_TURNO_AGENDADO";
export const ON_GRACIAS_PERSONAS = "ON_GRACIAS_PERSONAS";
export const ON_SUCURSALES = "ON_SUCURSALES";
